/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ScreenerSourceAllowName } from './ScreenerSourceAllowName';
import {
    ScreenerSourceAllowNameFromJSON,
    ScreenerSourceAllowNameFromJSONTyped,
    ScreenerSourceAllowNameToJSON,
    ScreenerSourceAllowNameToJSONTyped,
} from './ScreenerSourceAllowName';

/**
 * 
 * @export
 * @interface FindAllScreenerSourceAllowNamesResponse
 */
export interface FindAllScreenerSourceAllowNamesResponse {
    /**
     * 
     */
    data: Array<ScreenerSourceAllowName>;
    /**
     * 
     */
    total: number;
    /**
     * 
     */
    page: number;
    /**
     * 
     */
    limit: number;
    /**
     * 
     */
    has_next: boolean;
}

/**
 * Check if a given object implements the FindAllScreenerSourceAllowNamesResponse interface.
 */
export function instanceOfFindAllScreenerSourceAllowNamesResponse(value: object): value is FindAllScreenerSourceAllowNamesResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('page' in value) || value['page'] === undefined) return false;
    if (!('limit' in value) || value['limit'] === undefined) return false;
    if (!('has_next' in value) || value['has_next'] === undefined) return false;
    return true;
}

export function FindAllScreenerSourceAllowNamesResponseFromJSON(json: any): FindAllScreenerSourceAllowNamesResponse {
    return FindAllScreenerSourceAllowNamesResponseFromJSONTyped(json, false);
}

export function FindAllScreenerSourceAllowNamesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllScreenerSourceAllowNamesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(ScreenerSourceAllowNameFromJSON)),
        'total': json['total'],
        'page': json['page'],
        'limit': json['limit'],
        'has_next': json['has_next'],
    };
}

export function FindAllScreenerSourceAllowNamesResponseToJSON(json: any): FindAllScreenerSourceAllowNamesResponse {
    return FindAllScreenerSourceAllowNamesResponseToJSONTyped(json, false);
}

export function FindAllScreenerSourceAllowNamesResponseToJSONTyped(value?: FindAllScreenerSourceAllowNamesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(ScreenerSourceAllowNameToJSON)),
        'total': value['total'],
        'page': value['page'],
        'limit': value['limit'],
        'has_next': value['has_next'],
    };
}

